export const Lights = () => (
  <>
    <ambientLight intensity={0.7} />
    <hemisphereLight args={['#ffffff', '#d9d9d9', 0.55]} />
    <directionalLight position={[4, 6, 3]} intensity={1.2} color="#ffffff" />
    <directionalLight position={[-3, 2, -4]} intensity={0.5} color="#ffffff" />
  </>
)
